import { memo } from "react";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const PaymentMethodsLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].PaymentMethods}`}
        Icon={CreditScoreIcon}
        {...props}
    >
        Payment Methods
    </StepLabel>
);

export default memo(PaymentMethodsLabel);
